import { Box } from "@mui/material";
import { DateTime } from "luxon";
import { type FC, useState } from "react";
import { usePbjCalculator } from "./hooks";
import { PbjCalculatorData } from "./PbjCalculatorData";
import { PbjCalculatorHeader } from "./PbjCalculatorHeader";

// CMS publishes PBJ quarterly and about two quarters in arrears, so the newest month we actually
// hold trails today by roughly this much. Anchoring the default window here keeps it inside real
// data — plain now() would run months past the end of it and the analysis would cover less than a
// year without saying so.
const CMS_PUBLICATION_LAG_MONTHS = 5;
const DEFAULT_RANGE_MONTHS = 12;

const defaultEndMonth = (): DateTime => DateTime.now().startOf("month").minus({ months: CMS_PUBLICATION_LAG_MONTHS });

export const PbjCalculator: FC = () => {
	const { mutateAsync: calculatePbj, data, isPending, error } = usePbjCalculator();
	const [startMonth, setStartMonth] = useState<DateTime>(() => defaultEndMonth().minus({ months: DEFAULT_RANGE_MONTHS - 1 }));
	const [endMonth, setEndMonth] = useState<DateTime>(defaultEndMonth);

	return (
		<Box sx={{ p: 3, maxWidth: "1400px", margin: "0 auto", height: "100%", overflow: "auto" }}>
			<PbjCalculatorHeader
				onCalculate={calculatePbj}
				isPending={isPending}
				startMonth={startMonth}
				setStartMonth={setStartMonth}
				endMonth={endMonth}
				setEndMonth={setEndMonth}
				calculatedData={data}
			/>

			<PbjCalculatorData data={data} error={error} startMonth={startMonth} endMonth={endMonth} />
		</Box>
	);
};
